export default {
  sulamerica: {
    primary: '#f58236',
    contrast: 'white',
  },
  dimensa: {
    primary: '#b9e600',
    contrast: 'black',
  }
}
